export default class YPResourcBookingObject {
  constructor(bookingJSON) {
    this.id = bookingJSON.id;
    this.name = bookingJSON.resource.name;
    this.role = bookingJSON.role;
    // eslint-disable-next-line no-underscore-dangle
    this.bookingType = bookingJSON._type;
    this.resourceType = bookingJSON.resource.resourcetype;
    /* The attribute "resourcegroup" is newly added to the API, we need to support
     * resources with and without this attribute. The attribute can only be available for grouped human resources  */
    this.hasResourceGroupFeatureFlag = 'resourcegroup' in bookingJSON;
    this.resourceGroup = this.hasResourceGroupFeatureFlag
      ? bookingJSON.resourcegroup
      : bookingJSON.resource.group;
    this.number = bookingJSON.number;
    this.start = bookingJSON.start;
    this.end = bookingJSON.end;
    this.unpublished = bookingJSON.unpublished;
    this.children = bookingJSON.children
      ? bookingJSON.children.map(
          (childBooking) => new YPResourcBookingObject(childBooking)
        )
      : null;
  }

  getOnlyChildBooking() {
    if (this.hasOnlyOneChildBooking()) return this.children[0];
    return null;
  }

  isResourceBookingGroup() {
    return this.bookingType === 'resourcebookinggroup';
  }

  isOfType(typeString) {
    return this.resourceType.toUpperCase() === typeString.toUpperCase();
  }

  isForHumanResource() {
    return this.isOfType('human');
  }

  isForSet() {
    return this.isOfType('set');
  }

  hasOnlyOneChildBooking() {
    return this.children && this.children.length === 1;
  }

  hasChildren() {
    return this.children && this.children.length > 0;
  }

  isOfTypeorHasChildOfType(typeString) {
    if (this.isForSet())
      return this.children.reduce(
        (foundChildOfType, child) =>
          foundChildOfType || child.isOfTypeorHasChildOfType(typeString),
        false
      );
    return this.isOfType(typeString);
  }

  hasResourceGroupFeature() {
    return this.isForHumanResource() && this.hasResourceGroupFeatureFlag;
  }

  printBookingWithRoleString() {
    if (this.isForSet()) return '';
    const roleString = this.role ? ` – ${this.role}` : '';
    return `${this.name}${roleString}${
      this.unpublished ? ` (${i18n('Unpublished')})` : ''
    }`;
  }

  printQuantityString() {
    if (this.isForSet()) return '';
    return `× ${this.number}`;
  }

}
